import { render, staticRenderFns } from "./BookingAssignmentHistoryDialog.vue?vue&type=template&id=0895c357&scoped=true&"
import script from "./BookingAssignmentHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./BookingAssignmentHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./BookingAssignmentHistoryDialog.vue?vue&type=style&index=0&id=0895c357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895c357",
  null
  
)

export default component.exports